const manifest = {
  "name": "Custom Background",
  "description": "Make your editor look brand new.",
  "editorOnly": false,
  "tags": [
    "new"
  ],
  "info": [
    {
      "type": "notice",
      "text": "This may reduce performance",
      "id": "reducePerformance"
    }
  ],
  "credits": [
    {
      "name": "KOSHINO",
      "link": "https://github.com/KOSHINOawa"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ]
};
export default manifest;
